import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { EntityLinker, ENTITY_TYPES, Button, useLinkedEntitiesContext } from "@adsk/bim360-matrix-react-components";
import { addLinkedEntitiesAction, removeLinkedEntityAction } from '../../../../../redux/actions';
import meetings from "@adsk/bim360-matrix-react-components/es/plugins/meeting-item";
import issue from "@adsk/bim360-matrix-react-components/es/plugins/issue";
import { issueAttributesType } from "../../../../../constants/proptype-validation";
import classNames from "classnames";
import { viewTypes } from "../../../../../constants/view-types";
import { getCurrentViewType } from "../../../../../redux/selectors";
import { connect } from "../../../../../redux/connect";

const plugins = [meetings, issue];
const IssuePreviewDetailsTabLinkedReferencesBy = (props) => {
  const emptyStateRenderer = () => {
    return props.renderTitle
      ? <div className="IssuePreviewDetailsTabLinkedReferences__empty">
        <div className="IssuePreviewDetailsTabLinkedReferences__empty-placeholder">{T.translate('issueAttributes.linkedReferences.noReferences')}</div>
      </div>
      : null;
  };

  const emptyErrorRenderer = ({ retry }) => (
    <div className="IssuePreviewDetailsTabLinkedReferences__error">
      <span className="IssuePreviewDetailsTabLinkedReferences__error-title">{T.translate('issueAttributes.linkedReferences.referencedBy')}</span>
      <span className="IssuePreviewDetailsTabLinkedReferences__error-text">{T.translate('issueAttributes.linkedReferences.loadError')}</span>
      <Button
        className="IssuePreviewDetailsTabLinkedReferences__error-button"
        styleType={Button.StyleType.INLINE_LINK}
        onClick={retry}
      >
        {T.translate('issueAttributes.linkedReferences.tryAgain')}
      </Button>
    </div>
  );
  emptyErrorRenderer.propTypes = {
    retry: PropTypes.func.isRequired,
  };

  const { issue, viewType, container, renderTitle } = props;
  const divClassNames = classNames('IssuePreviewDetailsTabLinkedReferences', {
    'IssuePreviewDetailsTabLinkedReferences__narrow': viewType === viewTypes.DOCUMENT,
    'IssuePreviewDetailsTabLinkedReferences__wide': viewType === viewTypes.PROJECT,
  });


  return (
    <div className={divClassNames} >
      {renderTitle && <div className="IssuePreviewDetailsTabLinkedReferences__label">{T.translate('issueAttributes.linkedReferences.label')}</div>}
      <div className="IssuePreviewDetailsTabLinkedReferences__fieldWrapper">
        <EntityLinker container={container} plugins={plugins} sourceEntityType={ENTITY_TYPES.RFI} sourceEntityId={issue.id}
          allowAddingLinks={false}
          allowRemoveLinkedEntity={false}
          referenceListTitle={T.translate('issueAttributes.linkedReferences.referencedBy')}
          hideTitleOnEmpty
          showTitleInEmptyBlockError
          emptyStateRenderer={emptyStateRenderer}
          emptyErrorRenderer={emptyErrorRenderer}
        />
      </div>
    </div>
  );
};


IssuePreviewDetailsTabLinkedReferencesBy.displayName = 'IssuePreviewDetailsTabLinkedReferencesBy';

IssuePreviewDetailsTabLinkedReferencesBy.propTypes = {
  container: PropTypes.object.isRequired,
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
  linkedEntityContext: PropTypes.object,
  renderTitle: PropTypes.bool,
};


const mapStateToProps = (state) => ({
  viewType: getCurrentViewType(state),
});

const ConnectedIssuePreviewDetailsTabLinkedReferencesBy = connect(mapStateToProps, { addLinkedEntitiesAction, removeLinkedEntityAction })(IssuePreviewDetailsTabLinkedReferencesBy);

const WithLinkedEntitiesContext = (props) => {
  const linkedEntityContext = useLinkedEntitiesContext();
  return <ConnectedIssuePreviewDetailsTabLinkedReferencesBy {...props} linkedEntityContext={linkedEntityContext} />;
};

export default WithLinkedEntitiesContext;

